import { useTranslation } from 'react-i18next'

interface Props {
  visible: boolean
}

export function OfflineBanner({ visible }: Props) {
  const { t } = useTranslation()

  if (!visible) return null

  return (
    <div
      style={{
        backgroundColor: '#FEF3E2',
        borderBottom: '0.5px solid #F6C68A',
        padding: '8px 16px',
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        fontSize: '13px',
        color: '#92400E',
        flexShrink: 0,
        zIndex: 20,
        position: 'relative',
      }}
    >
      <span style={{ fontSize: '14px' }}>🌰</span>
      <span>{t('common.offlineBanner')}</span>
    </div>
  )
}
